// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__uaxRi","colCheckbox":"styles_colCheckbox__21x9Y"};